class WSliderImage extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this._swiper = null;
    this._swiperEl = this.querySelector('.w-slider-image__swiper');
    if (!this._swiperEl) return;

    const breakpoint = Number.parseInt(this.dataset.breakpoint, 10);
    this._breakpoint = Number.isNaN(breakpoint) ? 989 : breakpoint;
    this._mq = window.matchMedia(`(min-width: ${this._breakpoint}px)`);
    this._onChange = this._onChange.bind(this);

    this._onChange(this._mq);

    if (this._mq.addEventListener) {
      this._mq.addEventListener('change', this._onChange);
    } else if (this._mq.addListener) {
      this._mq.addListener(this._onChange);
    }
  }

  disconnectedCallback() {
    if (this._mq) {
      if (this._mq.removeEventListener) {
        this._mq.removeEventListener('change', this._onChange);
      } else if (this._mq.removeListener) {
        this._mq.removeListener(this._onChange);
      }
    }

    this._destroy();
    this._initialized = false;
  }

  _onChange(event) {
    if (event.matches) {
      this._destroy();
      return;
    }

    this._init();
  }

  _init() {
    if (this._swiper || !this._swiperEl || typeof Swiper === 'undefined') return;

    this._swiper = new Swiper(this._swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      loop: false
    });
  }

  _destroy() {
    if (!this._swiper) return;

    this._swiper.destroy(true, true);
    this._swiper = null;
  }
}

if (!customElements.get('w-slider-image')) {
  customElements.define('w-slider-image', WSliderImage);
}
